<template>
    <li>
        <router-link :to="to" @click.native="onRoute"><span>{{text}}</span></router-link>
    </li>
</template>

<script>
    export default {
        name: "MenuItem",
        props: [
            'to',
            'text'
        ],
        methods: {
            onRoute() {
                this.$store.dispatch('toggleMenu');
            }
        }
    };
</script>

<style scoped>
    
    li {display: block; box-sizing: border-box; background-color: transparent; transition: .25s; text-align: left;}
    li:hover {background: #2D2E30;}
        li > a {display: block; height: 100%; width: 100%; text-decoration: none; text-transform: uppercase; color: #000; padding: 1rem 1.5rem; font-family: var(--font-body); color: #fff; border-bottom: 1px solid #565759; font-size: .9rem; box-sizing: border-box;}
        li > a > span {margin-left: 0; transition: .25s;}
        li:hover > a > span {margin-left: 1rem;}

</style>